import { TypographyProps as MaterialTypographyProps } from '@mui/material';

export interface TypographyProps extends Omit<MaterialTypographyProps, 'variant'> {
  variant?: Variant;
}

export const TypographyVariants = {
  H1_SEMIBOLD: 'h1-semibold',
  H2_SEMIBOLD: 'h2-semibold',
  H3_SEMIBOLD: 'h3-semibold',
  H4_SEMIBOLD: 'h4-semibold',
  H5_SEMIBOLD: 'h5-semibold',
  H6_SEMIBOLD: 'h6-semibold',
  H7_SEMIBOLD: 'h7-semibold',
  H8_MEDIUM: 'h8-medium',
  H8_SEMIBOLD: 'h8-semibold',
  H8_5_REGULAR: 'h8.5-regular',
  BODY1_LIGHT: 'body1-light',
  BODY1_5_LIGHT: 'body1.5-light',
  BODY1_REGULAR: 'body1-regular',
  BODY1_5_REGULAR: 'body1.5-regular',
  BODY1_MEDIUM: 'body1-medium',
  BODY1_5_MEDIUM: 'body1.5-medium',
  BODY1_SEMIBOLD: 'body1-semibold',
  BODY2_LIGHT: 'body2-light',
  BODY2_5_LIGHT: 'body2.5-light',
  BODY2_REGULAR: 'body2-regular',
  BODY2_5_REGULAR: 'body2.5-regular',
  BODY2_MEDIUM: 'body2-medium',
  BODY2_5_MEDIUM: 'body2.5-medium',
  BODY2_SEMIBOLD: 'body2-semibold',
  BODY2_BOLD: 'body2-bold',
  BODY3_REGULAR: 'body3-regular',
  BODY3_5_REGULAR: 'body3.5-regular',
  BODY3_MEDIUM: 'body3-medium',
  BODY3_5_MEDIUM: 'body3.5-medium',
  BODY3_SEMIBOLD: 'body3-semibold',
  OVERLINE1_REGULAR: 'overline1-regular',
} as const;

export type Variant = (typeof TypographyVariants)[keyof typeof TypographyVariants];
